import {Component, OnInit} from "@angular/core";
import {BlogItem} from "./blog.component";
import {ActivatedRoute} from "@angular/router";
import {WSResponse} from "../portfolio/portfolio.datatypes";
import {BlogService} from "../blog.service";

@Component({
    selector: 'blog-item',
    templateUrl: './blog-item.component.html'
})

export class BlogItemComponent implements OnInit {
    blogItem: BlogItem;
    errorMsg: string;

    constructor(private route: ActivatedRoute, private blogService: BlogService) {
    }

    ngOnInit() {
        this.route.params.subscribe(params => {
            let slug = params['id'];
            this.getItem(slug);
        });
    }

    private getItem(slug: string) {
        let serverResponse: WSResponse;
        this.blogService.getBlogItem(slug)
            .subscribe(
                (data) => {
                    serverResponse = data;

                },
                (error) => this.errorMsg = <any>error,
                () => {
                    this.showItem(serverResponse);
                }
            )

    }

    private showItem(response: WSResponse) {
        if (response.success) {
            this.blogItem = response.message;
            this.blogItem.postDate = this.blogItem.postDate.replace(' ', 'T');
            this.initDisqus();
        }
    }

    private initDisqus() {
        var div = document.getElementById('disqus_thread');
        div.innerHTML = '';

        var dsq = document.createElement('script');
        dsq.type = 'text/javascript';
        dsq.async = true;
        dsq.src = 'https://adventmedia.disqus.com/embed.js';

        (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(dsq);
    }
}



// WEBPACK FOOTER //
// ./src/app/blog/blog-item.component.ts